module.exports = __webpack_public_path__ + "img/pic_btn_p.37785627.png";